// Checks if Airtable text contains markup
/**
 * Constructs Support URL based on current vertical
 * @param {string} content
 * @returns {boolean} true or false
 */
export const checkForMarkUp = (content) => /<[a-z][\s\S]*>/i.test(content);

// Converts content into dangerouslysethtml object
/**
 * Constructs Support URL based on current vertical
 * @param {string} content
 * @returns {object} __html var with content set as val to be used as dangerouslySetHTML atr
 */
export const createMarkup = (content) => ({ __html: content });
